import { render, staticRenderFns } from "./CommentsPostForm.vue?vue&type=template&id=8f3632cc&scoped=true&"
import script from "./CommentsPostForm.vue?vue&type=script&lang=ts&"
export * from "./CommentsPostForm.vue?vue&type=script&lang=ts&"
import style0 from "./CommentsPostForm.vue?vue&type=style&index=0&id=8f3632cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3632cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
